import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { UIValidator } from "../../../shared/validate/ui-validator.validate";

import {
  QuestionCtrlType,
  SurveyQuestion,
} from "../../../../../../shared-lib/src/public-api";

@Component({
  selector: "app-survey-question",
  templateUrl: "./survey-question.component.html",
  styleUrls: ["./survey-question.component.css"],
})
export class SurveyQuestionComponent {
  questionCtrlType = QuestionCtrlType;
  @Input() question: SurveyQuestion;
  @Input() form: FormGroup;
  @Input() submitted: boolean;

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls[this.question.id];
  }

  numberOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    return UIValidator.isNumberEvent(charCode);
  }
}
